module.exports = __webpack_public_path__ + "static/media/loginScreen2.5b0a76a6.svg";